import React from 'react'
import type { AppBarProps as MuiAppBarProps } from '@material-ui/core/AppBar'
import MuiAppBar from '@material-ui/core/AppBar'

export type AppBarProps = MuiAppBarProps

const AppBar = React.forwardRef<HTMLElement, AppBarProps>(function AppBar(props, ref) {
  return <MuiAppBar ref={ref} {...props} />
})

export default AppBar
